import React, { useContext } from 'react';
import { View, Pressable } from 'react-native';

import ClientContext from 'app/src/contexts/ClientContext';
import { Text } from 'app/src/styles';
import { Link } from 'app/src/utils/routing';

const Menu = () => {
  const { logout } = useContext(ClientContext);

  return (
    <View style={{ flexDirection: 'row', gap: 10 }}>
      <Link to="/">
        <Text>Home</Text>
      </Link>

      <Link to="/clients">
        <Text>Clients</Text>
      </Link>

      <Link to="/events">
        <Text>Events</Text>
      </Link>

      <Link to="/event-types">
        <Text>Event Types</Text>
      </Link>

      <Link to="/things">
        <Text>Things</Text>
      </Link>

      <Link to="/users">
        <Text>Users</Text>
      </Link>

      <Pressable onPress={logout}>
        <Text>Logout</Text>
      </Pressable>
    </View>
  );
};

export default Menu;
